/**
 * Skip to main content link for keyboard/screen reader users.
 * Visually hidden until focused via Tab key.
 */
export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="lx-skip-link sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:text-sm focus:font-semibold focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}
